import { Component, OnInit} from '@angular/core';
import { UserLogin } from '../../../Common/models/user.login';
import { ManageService } from '../../services/manage.service';
import { StatusService } from '../../../Common/services/status.service';
import { DatePipe } from '@angular/common';
import { RefTypeEnum } from '../../../project-intake/enums/ref-type-enum';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { MessageService } from '../../../project-intake/services/message.service';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { RoleKey } from '../../../Common/Constants/common.constants';

@Component({
  selector: 'retailhub-manage-projects',
  templateUrl: './retailhub-manage-projects.component.html',
  styleUrls: ['./retailhub-manage-projects.component.css','../../../../assets/css/new-project.css'],
  providers : [DatePipe]
})

export class RetailHubManageProjectsComponent implements OnInit {

  public selectedVendor: any;
  public categoryList :any[] = [];
  public userCategoryList :any[] = [];
  public agencies? :any[] = [];
  public statuses? :any[] = [];
  public projects? : any[] = [];
  selectedCategories: any[] = [];  
  selectedAgencies? :any[] = [];
  userAgencies?:any[] = [];
  selectedStatus? :any[] = [];

  sortColumn: string = 'initiatedDate';
  sortDirection: 'asc' | 'desc' = 'desc';

  constructor(private manageService: ManageService<Blob>, private statusService: StatusService
    ,private datepipe: DatePipe, private router: Router,private ngxService: NgxUiLoaderService,
     private toastr: ToastrService, private encodeDecodeService: CustomEncodeDecodeService,
     private msgService: MessageService,private userRoleService: UserRoleServiceService) {
      
  }

  ngOnInit(): void {  
    if(this.userRoleService.role?.roleKey == RoleKey.ITAdmin) {
      //alert("Un authorized access");
      this.router.navigate(['/unauthorized']);
      return;
    }
    this.getUserRoleInfo();
    this.getStatusMaster();
  }
  
  getUserRoleInfo(){
    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) { 
      let userRoleInfo : UserLogin = JSON.parse(atob(encodedVal));
      this.selectedVendor = userRoleInfo.vendors[0];
     // userRoleInfo.categories =  userRoleInfo.categories?.filter(v=>v.vendorID == this.selectedVendor.vendorID);
      this.categoryList = userRoleInfo.categories;              
      this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
      this.userCategoryList = userRoleInfo.userCategory;
      if(this.userRoleService.role?.roleID==4 || this.userRoleService.role?.roleID==1){
        this.selectedCategories = this.userCategoryList.map(a=>a.categoryID);
      } else {
        this.selectedCategories = this.categoryList.map(a=>a.value);
      }
      
      this.agencies = userRoleInfo.agencies;              
      this.agencies = this.agencies?.map((x: any) => ({ 'label': x.agencyName, 'value': x.agencyId }));
      this.userAgencies = this.agencies?.map(a=>a.value);
      
    }
  }
  getStatusMaster(){
    this.ngxService.start();
    this.statusService.GetStatusMasterData().subscribe({
      next:(data: any) => {     
        this.ngxService.stop();
        if(data){                    
          this.statuses = data?.map((x: any) => ({ 'label': x.statusName, 'value': x.statusID }));
         this.selectedStatus = this.statuses?.map(a=>a.value);
          this.getProjectData();
        }
      },
      error: (error) => {
        this.ngxService.stop();
        //this.toastr.error("Unexpected error occurred");
      }
    });
  }

  getProjectData(){
    if(this.userAgencies == this.selectedAgencies){
      this.selectedAgencies=[];
    }
     let manageDto = {
        categories : this.selectedCategories,
        agencies :  this.selectedAgencies,
        status : this.selectedStatus,
        type : "Project"
      };
    this.ngxService.start();
    this.manageService.GetManageProjectsData(manageDto).subscribe({
      next:(data: any) => {
        this.ngxService.stop();
          if(data){ 
            //Sort By Initiated Date Descending order
            data.sort((a: any, b: any) => {
              const dateA = a.initiatedDate ? new Date(a.initiatedDate).getTime() : 0;
              const dateB = b.initiatedDate ? new Date(b.initiatedDate).getTime() : 0;
              return dateB - dateA; 
            });

            data.forEach((element : any) => {
              element.initiatedDate = element.initiatedDate && this.datepipe.transform(element.initiatedDate, 'dd-MMM-yyyy');
              element.startDate = element.startDate && this.datepipe.transform(element.startDate, 'dd-MMM-yyyy');
              element.endDate = element.endDate && this.datepipe.transform(element.endDate, 'dd-MMM-yyyy'); 
              element.projectStatuses = this.mergeStatusData(element.projectStatuses);
            });
            
            //data.sort((a: { refId: number; }, b: { refId: number; }) => b.refId - a.refId);

            this.projects= data;
          }
      },
      error: (error) => {
        this.ngxService.stop();
      }
    });
  }

  navigateToComponent_bkp(id:number,catId:number) {
    this.router.navigate(['/projectintake/editproject', this.encodeDecodeService.encode(id),this.encodeDecodeService.encode(catId)]);
  }

  navigateToComponent(id:number,catId:number[]) {
    this.router.navigate(['/projectintake/editproject', this.encodeDecodeService.encode(id),this.encodeDecodeService.encode(catId)]);
  }

  mergeStatusData(projectStatuses : any){
    let mergedStatuses : any[] = [];
    this.statuses?.forEach((element : any) => {
      const matchedStatus = projectStatuses?.find((item : any) => item.statusID == element.value);
      mergedStatuses.push({
        "projectStatusText":element.label,
        "statusID" : element.value,
        "updatedBy" : matchedStatus?.changedByName,
        "updatedDate" : matchedStatus && this.datepipe.transform(matchedStatus?.changeDate, 'dd-MMM-yyyy') 
       });
    });
    return mergedStatuses;
  }
  
  exportProjectData(){
    let manageDto = {
      categories : this.selectedCategories,
      agencies :  this.selectedAgencies,
      status : this.selectedStatus,
      type : "Project"
    };
    this.manageService.ExportManageProjectSalesplanExcel(manageDto);
  }  

  downloadStoresExcel(event: Event, refId: number, projectTitle: string): void {
    this.manageService.downloadStoresExcel(event,refId, RefTypeEnum.Project, projectTitle);
  }

  downloadInstruction(event: Event, refId: number, projectTitle: string): void {
    event.preventDefault(); 
    event.stopPropagation(); 
    this.msgService.htmlInfo("Download Instruction file is inprogress..");
    this.ngxService.start();
    this.manageService.getInstructionsToDownload(refId, RefTypeEnum.Project).subscribe({
      next: (blob: Blob) => {
        this.ngxService.stop();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'DownloadedFiles.zip';  
        link.click(); 
        window.URL.revokeObjectURL(downloadUrl);
      },
      error: (error) => {
        this.ngxService.stop();
        //this.msgService.htmlError("Unexpected error occurred");
      }
    });
 
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  sortProjects(column: 'startDate' | 'endDate' | 'initiatedDate'): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.projects?.sort((a, b) => {
      const dateA = a[column] ? new Date(a[column]) : new Date(0);
      const dateB = b[column] ? new Date(b[column]) : new Date(0);

      return this.sortDirection === 'asc'
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    });
  }
}
